import { createI18n } from 'vue-i18n'
import { getEnv } from '@env'

const Locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)

const messages = {}

// Escape function for special symbols
function escapeSpecialSymbols(text) {
  if (typeof text === 'string') {
    return (
      text
        // Escaping '@' as {'@'}
        .replace(/@/g, "{'@'}")
        // Escaping '$' as {'$'}
        .replace(/\$/g, "{'$'}")
        // Escaping '|' as {'|'}
        .replace(/\|/g, "{'|'}")
    )
  }
  return text
}

// Recursive function to process all strings in a translation object
function processTranslations(obj) {
  if (typeof obj === 'string') {
    return escapeSpecialSymbols(obj)
  } else if (typeof obj === 'object' && obj !== null) {
    const result = {}
    for (const key in obj) {
      result[key] = processTranslations(obj[key])
    }
    return result
  }
  return obj
}

Locales.keys().forEach((lang) => {
  // Import translation file
  const langEntries = Locales(lang)
  // Extract locale key from filename
  const langName = lang.match(/(.*)(?=\.json)/g)[0].slice(2)
  // Escape special symbols in translations
  messages[langName] = processTranslations(langEntries)
})

export default createI18n({
  allowComposition: true,
  locale: getEnv('VUE_APP_FRONTEND_I18N_LOCALE') || 'lv_LV',
  fallbackLocale: getEnv('VUE_APP_FRONTEND_I18N_FALLBACK_LOCALE') || 'lv_LV',
  messages,
})
